
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { uploadRequest, getRequest } from '../../../helpers/axiosClient';
import actions from './actions';







export function* uploadFile(params) {
    try {
        let response = yield call(() => uploadRequest(`v1/fileprocessor/upload`, params.details, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }));
        yield put({
            type: actions.UPLOAD_SUCCESS,
            payload: `${params.title} successfully}`,
            data: response.data
        });
    } catch (error) {
        yield put({ type: actions.UPLOAD_FAILURE });
        return error;
    }
}

export function* getFile(params) {
    try {
        let response = yield call(() => getRequest(`${params.url}`));
        yield put({
            type: actions.GET_FILE_SUCCESS,
            data: response.data
        });
    } catch (error) {
        yield put({ type: actions.GET_FILE_FAILURE });
        return error;
    }
}

export function* clearUploadDetails() {
    yield put({
        type: actions.CLEAR_UPLOAD_SUCCESS,
    });
}


export default function* uploadSaga() {
    yield all([
        takeEvery(actions.UPLOAD_START, uploadFile),
        takeEvery(actions.GET_FILE_START, getFile),
        takeEvery(actions.CLEAR_UPLOAD_START, clearUploadDetails)
    ]);
}